<div class="open-button-container">
  <button class="ant-btn ant-btn-link ant-btn-round ant-btn-sm" ui-button uiSize="small" uiType="link" uiShape="round">Open</button>
</div>
